import React from 'react';
import './VideoCard.scss';
import appImage from '../../img/app.png';
import googleImage from '../../img/play.png';

function VideoCard() {
  return (
    <section class="videoCard">
      <h2 className="videoCard__title">Как начать родителю?</h2>
      <p className="videoCard__subtitle">
        Для начала выберите один из вариантов, который относится к вам?
      </p>
      <div className="container-video">
        <div className="instruction">
          <div className="instruction__box">
            <div className="instruction__box-number">
              <span className="instruction-number">1</span>
            </div>
            <div className="instruction__box-description">
              <div className="instruction__content-description">
                <p className="instruction__title">
                  Скачайте приложение Jusan —{' '}
                </p>
                <p className="instruction__subtitle">
                  вам не нужно посещать банк
                </p>
              </div>
              <div className="instruction__logo">
                <a
                  className="instruction-icon"
                  href="https://apps.apple.com/ru/app/jusan-junior/id1628559106"
                >
                  <img src={appImage} alt="app" />
                </a>
                <a
                  className=""
                  href="https://play.google.com/store/apps/details?id=kz.jysan.junior.app&hl=ru"
                >
                  <img src={googleImage} alt="google" />
                </a>
              </div>
            </div>
          </div>
          <div className="instruction__box">
            <div className="instruction__box-number">
              <span className="instruction-number">2</span>
            </div>
            <div className="instruction__box-description2">
              <p className="instruction__title">
                Регистрируйтесь в разделе <br></br>“Инвестиции”{' '}
              </p>
              <p className="instruction__subtitle">
                — нужен только телефон и доступ в интернет
              </p>
            </div>
          </div>
          <div className="instruction__box">
            <div className="instruction__box-number">
              <span className="instruction-number">3</span>
            </div>
            <div className="instruction__box-description3">
              <p className="instruction__title">Нажмите на Junior </p>
              <p className="instruction__subtitle">
                — и следуйте инструкциям на экране
              </p>
            </div>
          </div>
          <p className="instruction-title">Смотреть видео инструкцию</p>
        </div>
        <div className="videoBox">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/69tD5TE2WGw"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </section>
  );
}

export default VideoCard;
